module.exports = __webpack_public_path__ + "assets/img/11_485_big.7ec9d3b5.jpg";